import styled from "styled-components"

import { useStore } from "@state/store"
import globalStyles from "@data/globalStyles"
import CenterButton from "@components/CenterButton/CenterButton"

function Picker360({ arr, title, subtitle, activeIndexes }) {
  const currentTour = useStore((s) => s.currentTour)
  const setCurrentTour = useStore((s) => s.setCurrentTour)
  const socket = useStore((s) => s.socket)

  return (
    <PickerWrapper>
      {arr.map((obj, i) => {
        return (
          <Button
            key={i}
            style={{
              borderColor:
                currentTour === obj.index
                  ? globalStyles.colors.dark.accent
                  : "transparent",
            }}
          >
            <img
              alt=""
              src={obj.src}
              onClick={() => {
                setCurrentTour(obj.index)
                socket.emit("test", {
                  type: "texture",
                  count: obj.index,
                })
              }}
            />
            <CenterButton
              cue={currentTour === obj.index}
              onClick={() => {
                socket.emit("test", {
                  type: "center",
                })
                socket.emit("test", {
                  type: "texture",
                  count: obj.index,
                })
              }}
            />
            <h1>0{obj.index + 1}</h1>
          </Button>
        )
      })}
      <Title>
        {title[0]}
        <br />
        <span style={{ opacity: activeIndexes.includes(currentTour) ? 1 : 0 }}>
          {subtitle}
        </span>
      </Title>
    </PickerWrapper>
  )
}

export default Picker360

const PickerWrapper = styled.div`
  width: 100%;
  height: calc(100%/4);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 0rem;
`

const Button = styled.div`
  position: relative;
  height: 80%;
  width: 100%;
  border-radius: 1rem;
  font-size: 30px;
  overflow: hidden;
  cursor: pointer;
  pointer-events: all;
  border-width: 2px;
  border-style: solid;
  transition: border-color 0.8s ease-in-out;

  & img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 1rem;
  }

  & h1{
    position: absolute;
    right: 10px;
    bottom: 5px;
    opacity: 0.8;
    font-size: 2rem;
    z-index: 2;
    font-weight: 100;
  }
`

const Title = styled.div`
  position: relative;
  width: 100%;
  min-width: 20%;
  display: grid;
  place-content: start;
  font-size: 1.3rem;
  opacity: 0.8;
  text-align: center;
  color: ${globalStyles.colors.dark.accent};
  padding: 1rem;

  & span {
    margin-top: 5px;
    margin-right: auto;
    font-size: 1rem;
  }
`
